import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lightbulb } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errMsg } from "@/lib/api";

export default function ObjectiveAdvisor({ onApply, projectId, current }) {
  const [goals, setGoals] = useState([]); const [goal, setGoal] = useState(""); const [rec, setRec] = useState(null); const [err, setErr] = useState("");
  useEffect(() => { api.get("/ads-manager/options").then((r) => setGoals(r.data.goals)); }, []);
  useEffect(() => { if (goal) api.get("/ads-manager/recommend-objective", { params: { goal } }).then((r) => { setRec(r.data); setErr(""); }).catch((e) => setErr(errMsg(e))); }, [goal]);
  return (
    <div className="rounded-xl border border-cyan-500/30 bg-cyan-500/5 p-4 space-y-3" data-testid="objective-advisor">
      <div className="flex items-center gap-2 text-sm font-semibold"><Lightbulb className="h-4 w-4 text-cyan-600" />Which Meta objective fits your goal?</div>
      <Select value={goal} onValueChange={setGoal}><SelectTrigger data-testid="advisor-goal"><SelectValue placeholder="Choose your marketing goal" /></SelectTrigger>
        <SelectContent>{goals.map((g) => <SelectItem key={g.key} value={g.key}>{g.label}</SelectItem>)}</SelectContent></Select>
      {err && <p className="text-xs text-red-600">{err}</p>}
      {rec && (
        <div className="text-xs space-y-1" data-testid="advisor-result">
          <div>Recommended: <b data-testid="advisor-objective">{rec.objective_label}</b> ({rec.objective}) · {rec.destination_label} · {rec.goal_label}</div>
          <div className="text-slate-500">{rec.why} Suggested starting budget ₹{rec.daily_budget}/day.</div>
          {onApply ? <Button size="sm" disabled={current === rec.objective && false} onClick={() => onApply(rec)} data-testid="advisor-apply">Apply to this campaign</Button>
            : <Link to={`/campaigns?new=1&objective=${rec.objective}&goal=${rec.goal}${projectId ? `&project=${projectId}` : ""}`}><Button size="sm" data-testid="advisor-create">Create this campaign in Campaign Center</Button></Link>}
        </div>)}
    </div>
  );
}
